var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FilterSingleChip',{attrs:{"is-text":"","label":_vm.label || _vm.$t('search-filters.closing-before.name'),"items":_vm.items,"value":_vm.value || null},on:{"change":function($event){return _vm.$emit('change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }